import gql from 'graphql-tag';
import { SERVICE_REPORT_SELECTION } from '@/store/serviceReportSelection';
import { REPORT_TEMPLATE_IMAGE_REQUEST_FIELDS } from '@/store/reportTemplateImages';
import { ATTACHMENT_FIELDS } from './projectDocumentsFragment';
import { PROJECT_SERVICE_REPORT_PHOTO_FIELDS } from './projectServiceReportFields';

const PHOTO_LIST_SELECTION = PROJECT_SERVICE_REPORT_PHOTO_FIELDS.map(
  (field) => `${field} { ${ATTACHMENT_FIELDS} }`
).join('\n');

/**
 * Data of the block project-service-report-data ("Service: Erfasste Daten"): the cards
 * (`serviceReport`), the state the block requests, the photo lists of the cards and the template
 * images of the cards. Read through `Project.blocks.serviceReportData`, which checks the block's
 * read permission.
 */
export const PROJECT_SERVICE_REPORT_DATA_FIELDS = gql`
  fragment projectServiceReportDataFields on ProjectServiceReportDataBlock {
    id
    number
    serviceReport {
      ${SERVICE_REPORT_SELECTION}
    }
    serviceVerificationState
    ${PHOTO_LIST_SELECTION}
    reportTemplateImages {
      ...reportTemplateImageFields
    }
  }
  ${REPORT_TEMPLATE_IMAGE_REQUEST_FIELDS}
`;
